module.exports = __webpack_public_path__ + "img/ys.fafbaa46.png";